// ts-check

/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */

(function () {
  const MIN_WIDTH = 768;

  /* -------------------------------------------------------------------------- */
  /*                              Product Accordion                             */
  /* -------------------------------------------------------------------------- */
  document.addEventListener("DOMContentLoaded", function () {
    const productAccordionGroup = document.querySelectorAll(
      "[data-accordion-group].product-accordion"
    );
    const productAccordion = productAccordionGroup[0];
    const accordionTriggerButtons = productAccordion?.querySelectorAll(
      "[data-accordion-trigger]"
    );

    if (accordionTriggerButtons) {
      // Ensure all overlays are hidden on resize
      // document.addEventListener('theme:resize', (e) => {
      //   if (window.innerWidth < MIN_WIDTH) {
      //     accordionTriggerButtons.forEach((triggerButton) => {
      //       const triggerId = triggerButton.getAttribute('data-accordion-trigger');
      //       const accordionOverlay = document.querySelector(`[data-accordion-overlay="${triggerId}"]`);
      //       accordionOverlay.classList.add('is-hidden');
      //     });
      //   }
      // });

      accordionTriggerButtons.forEach((triggerButton) => {
        const triggerId = triggerButton.getAttribute("data-accordion-trigger");

        // triggerButton.addEventListener('click', (e) => {
        //   if (window.innerWidth < MIN_WIDTH) {
        //     return;
        //   }

        //   const accordionOverlay = document.querySelector(`[data-accordion-overlay="${triggerId}"]`);
        //   accordionOverlay.classList.remove('is-hidden');

        //   const allAccordionOverlays = document.querySelectorAll('[data-accordion-overlay]');

        //   const otherAccordionOverlays = Array.from(allAccordionOverlays).filter((overlay) => {
        //     return overlay.getAttribute('data-accordion-overlay') !== triggerId;
        //   });

        //   // Ensure all other overlays are hidden
        //   otherAccordionOverlays.forEach((overlay) => {
        //     overlay.classList.add('is-hidden');
        //   });
        // });

        // const closeButton = document.querySelector(`[data-accordion-close="${triggerId}"]`);

        // closeButton.addEventListener('click', (e) => {
        //   if (window.innerWidth < MIN_WIDTH) {
        //     return;
        //   }
        //   const accordionOverlay = document.querySelector(`[data-accordion-overlay="${triggerId}"]`);
        //   accordionOverlay.classList.add('is-hidden');
        // });
      });
    }
  });

  // /* -------------------------------------------------------------------------- */
  // /*                               Lookbooks Tabs                               */
  // /* -------------------------------------------------------------------------- */

  document.addEventListener("DOMContentLoaded", function () {
    const lookbookTabs = document.querySelectorAll("[data-lookbook-tab]");
    lookbookTabs.forEach((tab) => {
      tab.addEventListener("click", (e) => {
        const tabId = tab.getAttribute("data-lookbook-tab");
        const tabContent = document.querySelector(
          `[data-lookbook-tab-content="${tabId}"]`
        );
        const allTabContents = document.querySelectorAll(
          "[data-lookbook-tab-content]"
        );

        allTabContents.forEach((content) => {
          if (content.getAttribute("data-lookbook-tab-content") === tabId) {
            content.classList.add("active");
          } else {
            content.classList.remove("active");
          }
        });

        lookbookTabs.forEach((tab) => {
          if (tab.getAttribute("data-lookbook-tab") === tabId) {
            tab.classList.add("font-semibold");
          } else {
            tab.classList.remove("font-semibold");
          }
        });
      });
    });
  });

  /* -------------------------------------------------------------------------- */
  /*                            Cart Message Progress                           */
  /* -------------------------------------------------------------------------- */

  document.addEventListener("DOMContentLoaded", function () {
    document.addEventListener("theme:cart:change", function (event) {
      var cart = event.detail.cart;
      if (cart) {
        const cartProgressElem = document.querySelector(
          "#cart__message__progress"
        );

        if (cartProgressElem) {
          if (cart.item_count > 0) {
            cartProgressElem.classList.remove("is-hidden");
          } else {
            cartProgressElem.classList.add("is-hidden");
          }
        }
      }
    });
  });

  /* -------------------------------------------------------------------------- */
  /*                  Remove header__backfill from product pages                 */
  /* -------------------------------------------------------------------------- */

  // To allow smooth scrolling back to top on product pages, we need to remove the header__backfill element
  // as the default behavior would only allow the transparent header on pages that have a hero image.
  // So to avoid snapping back to the top of the page, we remove the header__backfill element on product pages.
  document.addEventListener("DOMContentLoaded", function () {
    const previewPath = new URLSearchParams(window.location.search).get(
      "previewPath"
    );
    if (
      window.location.pathname.includes("/products") ||
      (previewPath && decodeURIComponent(previewPath).includes("/products"))
    ) {
      const headerBackfill = document.querySelector(".header__backfill");
      if (headerBackfill) {
        headerBackfill.remove();
      }
    }
  });

  /* -------------------------------------------------------------------------- */
  /*                  Show editor note in Customization Editor                  */
  /* -------------------------------------------------------------------------- */

  document.addEventListener("DOMContentLoaded", function () {
    if (Shopify.designMode) {
      const faqEditorNoteElem = document.querySelector("#faq-editor-note");
      if (faqEditorNoteElem) {
        faqEditorNoteElem.classList.replace("hidden", "block");
      }
    }
  });

  /* -------------------------------------------------------------------------- */
  /*                 Collection Slider & Recommendations Scroll Buttons        */
  /* -------------------------------------------------------------------------- */

  document.addEventListener("DOMContentLoaded", function () {
    const sectionCollectionSliderWrappers = document.querySelectorAll(
      "#section-collection-slider-wrapper"
    );
    const cartRecommendationCarouselWrappers = document.querySelectorAll(
      "#cart-recommendation-carousel-wrapper"
    );

    const buttonFunction = (wrapper, scrollAmount) => {
      const scrollContainer = wrapper.querySelector("#scroll-container");
      const leftButton = wrapper.querySelector("#scroll-button-left");
      const rightButton = wrapper.querySelector("#scroll-button-right");

      // Touch-Swipe Variablen für horizontales Scrollen
      let isScrolling = false;
      let startX = 0;
      let startY = 0;
      let startScrollLeft = 0;
      let isHorizontalSwipe = false;

      // Function to update the visibility of scroll buttons
      function updateButtons() {
        // Hide left button if at start
        if (scrollContainer.scrollLeft <= 0) {
          leftButton.classList.add("hidden");
        } else {
          leftButton.classList.remove("hidden");
        }
        // Hide right button if at end
        if (
          scrollContainer.scrollLeft >=
          scrollContainer.scrollWidth - scrollContainer.clientWidth
        ) {
          rightButton.classList.add("hidden");
        } else {
          rightButton.classList.remove("hidden");
        }
      }

      // Touch Event Handlers für horizontales Scrollen auf Produktbildern
      function handleTouchStart(e) {
        if (e.touches.length === 1) {
          isScrolling = true;
          isHorizontalSwipe = false;
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          startScrollLeft = scrollContainer.scrollLeft;
        }
      }

      function handleTouchMove(e) {
        if (!isScrolling) return;

        const currentX = e.touches[0].clientX;
        const currentY = e.touches[0].clientY;

        const deltaX = startX - currentX;
        const deltaY = startY - currentY;

        // Bestimme Richtung nach einer Mindestbewegung
        if (
          !isHorizontalSwipe &&
          (Math.abs(deltaX) > 10 || Math.abs(deltaY) > 10)
        ) {
          isHorizontalSwipe = Math.abs(deltaX) > Math.abs(deltaY);
        }

        // Nur bei eindeutig horizontalen Swipes eingreifen
        if (
          isHorizontalSwipe &&
          Math.abs(deltaX) > Math.abs(deltaY) * 1.5 &&
          Math.abs(deltaX) > 10
        ) {
          e.preventDefault();
          // Sanftere Scroll-Geschwindigkeit (1.2x Multiplikator für flüssigeres Scrollen)
          scrollContainer.scrollLeft = startScrollLeft + deltaX * 1.2;
        }
        // Bei vertikaler Bewegung nicht eingreifen - normal scrollen lassen
      }

      function handleTouchEnd(e) {
        if (!isScrolling) return;

        // Nur bei eindeutig horizontalen Swipes Klicks verhindern
        if (
          isHorizontalSwipe &&
          Math.abs(startX - e.changedTouches[0].clientX) > 20
        ) {
          e.preventDefault();
          e.stopPropagation();
        }

        isScrolling = false;
        isHorizontalSwipe = false;
      }

      // Initial update of button visibility
      updateButtons();

      leftButton.addEventListener("click", function () {
        scrollContainer.scrollBy({ left: -scrollAmount, behavior: "smooth" });
      });

      rightButton.addEventListener("click", function () {
        scrollContainer.scrollBy({ left: scrollAmount, behavior: "smooth" });
      });

      // Touch Events für horizontales Scrollen
      scrollContainer.addEventListener("touchstart", handleTouchStart, {
        passive: true,
      });
      scrollContainer.addEventListener("touchmove", handleTouchMove, {
        passive: false,
      });
      scrollContainer.addEventListener("touchend", handleTouchEnd, {
        passive: false,
      });

      // Update button visibility on scroll events
      scrollContainer.addEventListener("scroll", updateButtons);
    };

    sectionCollectionSliderWrappers.forEach((wrapper) =>
      buttonFunction(
        wrapper,
        // Erhöhte Scroll-Distanz (50% der Viewport-Breite statt 30%)
        window.innerWidth * 0.5
      )
    );
    cartRecommendationCarouselWrappers.forEach((wrapper) =>
      buttonFunction(
        wrapper,
        // Erhöhte Scroll-Distanz für Cart Slider
        400
      )
    );
  });

  /* -------------------------------------------------------------------------- */
  /*                             PhotoSwipe Navigation                          */
  /* -------------------------------------------------------------------------- */
  // This code is for the PhotoSwipe navigation buttons (left, right, close) in the lightbox.
  (function () {
    document.addEventListener("DOMContentLoaded", function () {
      let lightbox = null;

      function handleLeftButtonClick(e) {
        if (!lightbox) return;
        lightbox.prev();
        e.preventDefault();
      }

      function handleRightButtonClick(e) {
        if (!lightbox) return;
        lightbox.next();
        e.preventDefault();
      }

      function handleCloseButtonClick(e) {
        if (!lightbox) return;
        lightbox.close();
        e.preventDefault();
      }

      document.addEventListener("theme:lightbox:open", function (event) {
        const _lightbox = event.detail.gallery;
        lightbox = _lightbox;
        if (!lightbox) return;
        const leftButton = document.querySelector(".pswp__button--arrow--left");
        const rightButton = document.querySelector(
          ".pswp__button--arrow--right"
        );
        const closeButton = document.querySelector(".pswp__button--close");

        leftButton.addEventListener("click", handleLeftButtonClick);
        rightButton.addEventListener("click", handleRightButtonClick);
        closeButton.addEventListener("click", handleCloseButtonClick);
      });

      document.addEventListener("theme:lightbox:close", function (event) {
        const leftButton = document.querySelector(".pswp__button--arrow--left");
        const rightButton = document.querySelector(
          ".pswp__button--arrow--right"
        );
        const closeButton = document.querySelector(".pswp__button--close");

        if (leftButton)
          leftButton.removeEventListener("click", handleLeftButtonClick);
        if (rightButton)
          rightButton.removeEventListener("click", handleRightButtonClick);
        if (closeButton)
          closeButton.removeEventListener("click", handleCloseButtonClick);

        lightbox = null;
      });
    });
  })();

  /* -------------------------------------------------------------------------- */
  /*                        PhotoSwipe custom navigation                        */
  /* -------------------------------------------------------------------------- */

  // PhotoSwipe custom navigation for zoom lightbox
  // (function () {
  //   document.addEventListener('DOMContentLoaded', function () {
  //     // We'll store the reference to the active PhotoSwipe instance
  //     let activePhotoSwipeInstance = null;

  //     // A function to monitor when PhotoSwipe is available and patch it
  //     const setupPhotoSwipeInterception = function () {
  //       // Check if PhotoSwipe is loaded
  //       if (!window.themePhotoswipe || !window.themePhotoswipe.PhotoSwipe) {
  //         // If PhotoSwipe isn't loaded yet, try again in a moment
  //         setTimeout(setupPhotoSwipeInterception, 100);
  //         return;
  //       }

  //       // Get a reference to the original PhotoSwipe constructor
  //       const OriginalPhotoSwipe = window.themePhotoswipe.PhotoSwipe.default;

  //       console.log('OriginalPhotoSwipe', OriginalPhotoSwipe);

  //       const right = document.querySelector('.pswp__button--arrow--right');

  //       console.log('window.pswp', window.pswp);

  //       console.log('leftButton', right);

  //       right.addEventListener('click', function (e) {
  //         console.log('leftButton clicked');

  //         const pswp = OriginalPhotoSwipe;
  //         console.log('pswp', pswp);
  //         if (!pswp) return;

  //         pswp.next();
  //         e.preventDefault();
  //       });

  //       // Create a new constructor function that wraps the original
  //       window.themePhotoswipe.PhotoSwipe.default = function () {
  //         // Call the original constructor with the same arguments
  //         const pswpInstance = new OriginalPhotoSwipe(...arguments);

  //         console.log('pswpInstance', pswpInstance);

  //         // Store the active instance for our navigation buttons to use
  //         activePhotoSwipeInstance = pswpInstance;

  //         // Listen for when the PhotoSwipe instance is destroyed (closed)
  //         pswpInstance.listen('destroy', function () {
  //           activePhotoSwipeInstance = null;
  //         });

  //         // Listen for when the PhotoSwipe is fully initialized
  //         pswpInstance.listen('initialZoomInEnd', function () {
  //           // Set a global reference that our click handlers can use
  //           window.PSWP_OPEN_INSTANCE = pswpInstance;

  //           // Dispatch an event that other code can listen for
  //           document.dispatchEvent(
  //             new CustomEvent('pswpOpen', {
  //               detail: { instance: pswpInstance },
  //             })
  //           );
  //         });

  //         return pswpInstance;
  //       };

  //       // Copy all properties from the original constructor's prototype
  //       for (const prop in OriginalPhotoSwipe.prototype) {
  //         if (OriginalPhotoSwipe.prototype.hasOwnProperty(prop)) {
  //           window.themePhotoswipe.PhotoSwipe.default.prototype[prop] = OriginalPhotoSwipe.prototype[prop];
  //         }
  //       }
  //     };

  //     // Start the interception setup
  //     setupPhotoSwipeInterception();

  //     // Function to get the current active PhotoSwipe instance
  //     const getCurrentPhotoSwipe = function () {
  //       return activePhotoSwipeInstance || window.PSWP_OPEN_INSTANCE;
  //     };

  //     // Handle click events for custom PhotoSwipe UI buttons
  //     document.body.addEventListener('click', function (e) {
  //       // Find the closest button if there is one
  //       const leftArrow = e.target.closest('.pswp__button--arrow--left');
  //       const rightArrow = e.target.closest('.pswp__button--arrow--right');
  //       const closeButton = e.target.closest('.pswp__button--close');

  //       // If none of our targets were clicked, do nothing
  //       if (!leftArrow && !rightArrow && !closeButton) return;

  //       // Try to get the active PhotoSwipe instance
  //       const pswp = getCurrentPhotoSwipe();
  //       if (!pswp) return;

  //       // Handle the appropriate action based on which button was clicked
  //       if (leftArrow) {
  //         pswp.prev();
  //         e.preventDefault();
  //       } else if (rightArrow) {
  //         pswp.next();
  //         e.preventDefault();
  //       } else if (closeButton) {
  //         pswp.close();
  //         e.preventDefault();
  //       }
  //     });

  //     // Set up keyboard navigation for accessibility
  //     document.addEventListener('keydown', function (e) {
  //       // Only process if we have an active PhotoSwipe and it's open
  //       const pswp = getCurrentPhotoSwipe();
  //       if (!pswp || !document.querySelector('.pswp--open')) return;

  //       // Handle navigation with arrow keys
  //       if (e.key === 'ArrowLeft') {
  //         pswp.prev();
  //       } else if (e.key === 'ArrowRight') {
  //         pswp.next();
  //       } else if (e.key === 'Escape') {
  //         pswp.close();
  //       }
  //     });
  //   });
  // })();

  /* -------------------------------------------------------------------------- */
  /*                        Initialize Overlayscrollbars                        */
  /* -------------------------------------------------------------------------- */

  // const { OverlayScrollbars, ClickScrollPlugin } = OverlayScrollbarsGlobal;

  // // optional: use the ClickScrollPlugin to make the option "scrollbars.clickScroll: true" available
  // OverlayScrollbars.plugin(ClickScrollPlugin);

  // // Get all elements with the data-overlayscrollbars-initialize attribute
  // const overlayScrollbarsElements = document.querySelectorAll('[data-overlayscrollbars-initialize]');

  // console.log('overlayScrollbarsElements', overlayScrollbarsElements);

  // overlayScrollbarsElements.forEach((element) => {
  //   try {
  //     const options = element.dataset.overlayscrollbarsOptions
  //       ? JSON.parse(element.dataset.overlayscrollbarsOptions)
  //       : {};

  //     console.log('options', options);

  //     OverlayScrollbars(element, {
  //       ...options,
  //       scrollbars: {
  //         ...options.scrollbars,
  //         clickScroll: true,
  //       },
  //       // overflow: {
  //       //   x: 'scroll',
  //       //   y: 'hidden',
  //       // },
  //     });
  //   } catch (error) {
  //     console.log('Could not parse scrollbar options on element', element);
  //   }
  // });
})();

// (function() {

//   // Below are example event listeners.  They listen for theme events that Pipeline
//   // fires in order to make it easier for you to add customizations.

//   // Keep your scripts inside this IIFE function call to avoid leaking your
//   // variables into the global scope.

//   document.addEventListener('theme:variant:change', function(event) {
//     // You might use something like this to write a pre-order feature or a
//     // custom swatch feature.
//     var variant = event.detail.variant;
//     var container = event.target;
//     if (variant) {
//       console.log('Container ———————— ↓');
//       console.log(container);
//       console.log('Variant —————————— ↓');
//       console.log(variant);
//       // ... update some element on the page
//     }
//   });

//   document.addEventListener('theme:cart:change', function(event) {
//     var cart = event.detail.cart;
//     if (cart) {
//       console.log('Cart ———————————— ↓');
//       console.log(cart);
//       // ... update an app or a custom shipping caluclator
//     }
//   });
//   // Fired when page loads to update header values
//   document.addEventListener('theme:cart:init', (e) => {
//     console.log('theme:cart:init');
//     console.log(e);
//   });

//   // Debounced scroll listeners.  Up and down only fire on direction changes
//   // These events are useful for creating sticky elements and popups.
//   document.addEventListener('theme:scroll', e => { console.log(e); });
//   document.addEventListener('theme:scroll:up', e => { console.log(e); });
//   document.addEventListener('theme:scroll:down', e => { console.log(e); });

//   // Debounced resize listener to bundle changes that trigger document reflow
//   document.addEventListener('theme:resize', e => { console.log(e); });

//   // Locks and unlocks page scroll for modals and drawers
//   // These are commented out because firing them will lock the page scroll
//   // the lock event must set `detail` to the modal or drawer body so the
//   // scroll locking code knows what element should maintain scoll.
//   // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
//   // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

//   // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
//   // variables into the global scope.
// })();

// ------------- Start - Model View -------------

function setCookie(name, value) {
  document.cookie = name + "=" + (value || "") + "; path=/";
}

function getCookie(name) {
  const value = "; " + document.cookie;
  const parts = value.split("; " + name + "=");
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
}

document.addEventListener("DOMContentLoaded", function () {

  const savedView = getCookie("view_mode");

  if (savedView === "cloth_view" || savedView == null) {
    document.querySelector(".cloth_view_btn")?.classList.add("active_view");
    toggleView(false);
  } else if (savedView === "model_view") {
    document.querySelector(".model_view_btn")?.classList.add("active_view");
    toggleView(true);
  }

  setTimeout(()=>{
    document.body.classList.remove("initial-load");
  },250);

});

document.addEventListener("click", function (e) {
  const togglebtn = e.target.closest(".toggle_view");
  const pagination = e.target.closest('a[data-filter-update-url]')
  if (togglebtn) {

    document.querySelectorAll(".toggle_view").forEach(el => {
      el.classList.remove("active_view");
    });

    togglebtn.classList.add("active_view");

    if (togglebtn.classList.contains("cloth_view_btn")) {
      setCookie("view_mode", "cloth_view");
      toggleView(false);
    } else if (togglebtn.classList.contains("model_view_btn")) {
      setCookie("view_mode", "model_view");
      toggleView(true);
    }
  }
  if(pagination){
    document.body.classList.add("initial-load");
    setTimeout(()=>{
      const savedView = getCookie("view_mode");

      if (savedView === "cloth_view") {
        document.querySelector(".cloth_view_btn")?.classList.add("active_view");
        toggleView(false);
      } else if (savedView === "model_view") {
        document.querySelector(".model_view_btn")?.classList.add("active_view");
        toggleView(true);
      }
      document.body.classList.remove("initial-load");
    },3500);
  }
});


function toggleView(selectedView) {
  if (selectedView) {
    // model view
    document.querySelectorAll(".product-grid-item").forEach((item) => {
      item.classList.add("modelView_active");
    });
  } else {
    // cloth view
    document.querySelectorAll(".product-grid-item").forEach((item) => {
      item.classList.remove("modelView_active");
    });
  }
}

// ------------- End - Model View -------------

/* -------------------------------------------------------------------------- */
/*     Product Page: keep current image when size variant is selected         */
/* -------------------------------------------------------------------------- */
// The theme dispatches "theme:image:change" on [data-product-slideshow] when
// a variant is selected. We intercept it in the capture phase (fires before
// the slideshow's own listener) so the displayed image never jumps.
document.addEventListener('theme:image:change', function (e) {
  // Ausnahme: der Wendejacken-Umschalter soll den Slider bewusst wechseln
  if (e.detail && e.detail.wende) return;
  e.stopImmediatePropagation();
}, true);

/* -------------------------------------------------------------------------- */
/*     Product Grid Item: Slider (hover-cycling off, arrows, swipe, pagination) */
/* -------------------------------------------------------------------------- */
(function () {
  var MOBILE_BP = 768;

  function isMobileNow() {
    return window.innerWidth < MOBILE_BP;
  }

  /* ---------- helpers ---------- */

  // Switch the visible image on a product-grid-item-variant element
  function showImage(variant, index) {
    var images = variant.querySelectorAll('[data-grid-image]');
    var count = images.length;
    if (!count || count <= 1) return false;
    var target = images[index % count];
    if (!target) return false;

    // Preload: replace <template> with actual img if needed
    target.setAttribute('loading', 'eager');

    // Update active state (triggers ProductGridItemImage CSS transition)
    images.forEach(function (img) { img.removeAttribute('data-grid-current-image'); });
    target.setAttribute('data-grid-current-image', 'true');
    return true;
  }

  // Get the current image index
  function currentIndex(variant) {
    var active = variant.querySelector('[data-grid-image][data-grid-current-image]');
    return active ? parseInt(active.getAttribute('data-grid-image'), 10) : 0;
  }

  // Get total image count on a variant
  function imageCount(variant) {
    return variant.querySelectorAll('[data-grid-image]').length;
  }

  // Update the wandering pagination bar
  function syncBar(variant, idx) {
    variant.querySelectorAll('[data-grid-page]').forEach(function (span) {
      var i = parseInt(span.getAttribute('data-grid-page'), 10);
      // Remove is-active so theme's "is-active ~ span { --width: 0% !important }" doesn't block our inline style
      span.classList.remove('is-active');
      span.style.setProperty('--width', i === idx ? '100%' : '0%');
    });
  }

  // Build mobile pagination bars for a variant (idempotent)
  function buildPagination(variant) {
    if (variant.querySelector('[data-grid-pagination]')) return;
    var holder = variant.querySelector('[data-grid-images]');
    if (!holder) return;
    var count = imageCount(variant);
    if (count <= 1) return;

    var wrap = document.createElement('div');
    wrap.className = 'product-grid-item__pagination';
    wrap.setAttribute('data-grid-pagination', '');
    for (var i = 0; i < count; i++) {
      var span = document.createElement('span');
      span.setAttribute('data-grid-page', i);
      // No is-active class — we control --width purely via inline style in syncBar
      span.style.setProperty('--width', i === 0 ? '100%' : '0%');
      wrap.appendChild(span);
    }
    // Insert before the images div inside the <a> tag
    holder.parentNode.insertBefore(wrap, holder);
  }

  /* ---------- disable hover auto-cycling ---------- */
  function patchTheme() {
    var PGI = customElements.get('product-grid-item-variant');
    if (!PGI) return;
    var proto = PGI.prototype;

    // Kill the auto-cycling timer (called by mouseenter and changePaging)
    proto.progressPaging = function () {};
    // Prevent mouseleave from resetting to image 0
    proto.resetSlideshow = function () {};
  }

  // Returns true if the element is inside a carousel/slider (swipe handled externally)
  function insideCarousel(el) {
    return !!el.closest('flickity-carousel, [data-carousel], .horizontal-scroll, #section-collection-slider-wrapper, #cart-recommendation-carousel-wrapper');
  }

  /* ---------- init mobile pagination ---------- */
  function initMobilePagination() {
    if (!isMobileNow()) return;
    document.querySelectorAll('product-grid-item-variant').forEach(function (el) {
      if (insideCarousel(el)) return; // no bars in Flickity carousels
      try {
        buildPagination(el);
        syncBar(el, 0);
      } catch (e) { /* skip bad elements */ }
    });
  }

  // Run after custom elements are defined
  function init() {
    patchTheme();
    initMobilePagination();
  }

  if (customElements.get('product-grid-item-variant')) {
    init();
  } else {
    customElements.whenDefined('product-grid-item-variant').then(init);
  }

  // Also build pagination for elements added later (infinite scroll, quickview)
  document.addEventListener('theme:section:load', initMobilePagination);

  // Build pagination for product cards loaded via AJAX (related / complementary sections)
  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      if (!isMobileNow()) return;
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          var variants = node.tagName === 'PRODUCT-GRID-ITEM-VARIANT'
            ? [node]
            : Array.from(node.querySelectorAll('product-grid-item-variant'));
          variants.forEach(function (el) {
            if (insideCarousel(el)) return;
            try { buildPagination(el); syncBar(el, 0); } catch (e) {}
          });
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- desktop: arrow button clicks ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pgi-arrow]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var variant = btn.closest('product-grid-item-variant');
    if (!variant) return;
    var count = imageCount(variant);
    if (count <= 1) return;

    var cur = currentIndex(variant);
    var dir = btn.getAttribute('data-pgi-arrow');
    var next = dir === 'next' ? (cur + 1) % count : (cur - 1 + count) % count;

    if (showImage(variant, next)) syncBar(variant, next);
  });

  /* ---------- mobile: touch swipe ---------- */
  // Use a single variable — avoids iOS Safari e.target drift issue
  var swipe = null; // { holder, variant, startX, startY, isHorizontal }

  document.addEventListener('touchstart', function (e) {
    var holder = e.target.closest('[data-grid-images]');
    if (!holder) return;
    var variant = holder.closest('product-grid-item-variant');
    if (!variant) return;
    if (imageCount(variant) <= 1) return;
    // Don't intercept swipes inside a Flickity carousel — let Flickity handle them
    if (variant.closest('flickity-carousel, [data-carousel]')) return;

    swipe = {
      holder: holder,
      variant: variant,
      startX: e.touches[0].clientX,
      startY: e.touches[0].clientY,
      isHorizontal: null,
    };
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (!swipe) return;
    var dx = e.touches[0].clientX - swipe.startX;
    var dy = e.touches[0].clientY - swipe.startY;

    if (swipe.isHorizontal === null && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
      swipe.isHorizontal = Math.abs(dx) > Math.abs(dy);
    }
    if (swipe.isHorizontal) {
      e.preventDefault(); // prevent page scroll on horizontal swipe
    }
  }, { passive: false });

  document.addEventListener('touchend', function (e) {
    if (!swipe) return;
    var s = swipe;
    swipe = null;

    if (!s.isHorizontal) return;

    var dx = e.changedTouches[0].clientX - s.startX;
    if (Math.abs(dx) < 30) return;

    var count = imageCount(s.variant);
    if (count <= 1) return;

    var cur = currentIndex(s.variant);
    var next = dx < 0 ? (cur + 1) % count : (cur - 1 + count) % count;

    if (showImage(s.variant, next)) syncBar(s.variant, next);

    // Prevent the touchend from navigating to the product page
    s.holder.addEventListener('click', function block(ev) {
      ev.preventDefault();
      s.holder.removeEventListener('click', block);
    }, { once: true, capture: true });
  }, { passive: false });

  document.addEventListener('touchcancel', function () { swipe = null; }, { passive: true });
})();

// ------------- Start - Videoplay Button -------------

document.addEventListener("DOMContentLoaded", function () {
  const videoplayBtn = document.querySelector('.product-video-playbtn');
  const meta_popup_video = document.querySelector('.meta_popup_video');
  const videopopup_close = document.querySelector('.product-video-popup-close');
  const videopopup_overlay = document.querySelector('.video-popup-overlay');

  function closePopup() {
    document.body.classList.remove('pdp_video_active');

    if (meta_popup_video) {
      meta_popup_video.pause();
      // meta_popup_video.currentTime = 0;
    }
  }

  if (videoplayBtn && meta_popup_video) {
    videoplayBtn.addEventListener('click', function () {
      document.body.classList.add('pdp_video_active');
      meta_popup_video.play();
    });
  }

  if (videopopup_close) {
    videopopup_close.addEventListener('click', closePopup);
  }

  if (videopopup_overlay) {
    videopopup_overlay.addEventListener('click', closePopup);
  }
  
});

// ------------- End - Videoplay Button -------------
